export function getIconByStorklevel(authLevel) {
    switch (authLevel) {
        case 'STORK-QAA-Level-1':
        case 'STORK-QAA-Level-2':
            return 'ba-icon-trust-low';
        case 'STORK-QAA-Level-3':
            return 'ba-icon-trust-medium';
        case 'STORK-QAA-Level-4':
            return 'ba-icon-trust-high';
    }
}
